import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  moduleContent: {
    paddingLeft: pxToRem(30),
    paddingRight: pxToRem(30),
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
});
